import { db, storage } from "./config"
import { collection, addDoc, getDocs, query, where, doc, updateDoc, getDoc } from "firebase/firestore"
import { getDownloadURL, ref, uploadBytes } from "firebase/storage"

export const createOffer = async (userId, card, originalPrice, offerPrice) => {
    try {
        // Reference to the "offers" collection
        const offersRef = collection(db, "offers")

        // Add a new document with a generated ID
        const docRef = await addDoc(offersRef, {
            sender: userId,
            receiver: card.seller,
            cardId: card.id,
            picture: card.pictures[0],
            title: card.title,
            created_at: new Date(),
            original_price: originalPrice,
            offer_price: offerPrice,
            state: 'pending'
        })

        console.log("Document written with ID: ", docRef.id)
    } catch (e) {
        console.error("Error adding document: ", e)
    }
}

export const getSentOffersByUserId = async (userId) => {
    try {
        // Reference to the "offers" collection
        const offersRef = collection(db, "offers")

        const offers = []

        // Create a query to filter offers by sellerId
        const q = query(offersRef, where("sender", "==", userId))
        const querySnapshot = await getDocs(q)

        querySnapshot.forEach((doc) => {
            offers.push({ id: doc.id, ...doc.data() })
        })

        return offers // Return the array of offers
    } catch (e) {
        console.error("Error getting documents: ", e)
        return [] // Return an empty array in case of error
    }
}

export const getReceivedOffersByUserId = async (userId) => {
    try {
        // Reference to the "offers" collection
        const offersRef = collection(db, "offers")

        const offers = []

        // Create a query to filter offers by sellerId
        const q = query(offersRef, where("receiver", "==", userId))
        const querySnapshot = await getDocs(q)

        querySnapshot.forEach((doc) => {
            offers.push({ id: doc.id, ...doc.data() })
        })

        return offers // Return the array of offers
    } catch (e) {
        console.error("Error getting documents: ", e)
        return [] // Return an empty array in case of error
    }
}

export const updateOffer = async (updatedData) => {
    try {
        // Reference to the specific offer document
        const offerRef = doc(db, "offers", updatedData.id)

        // Update the document with new data
        await updateDoc(offerRef, updatedData)

        console.log("Document updated with ID: ", updatedData.id)
    } catch (e) {
        console.error("Error updating document: ", e)
    }
}
